<script lang="ts">
  import type { AvaliableProducts, Product } from "../../helpers/types";
  import VariablePrice from "./VariablePrice.svelte";
  import FixedPrice from "./FixedPrice.svelte";
  import Card from "../atoms/Card.svelte";
  import AnimatedText from "../molecules/AnimatedText.svelte";
  import { onDestroy, onMount } from "svelte";
  import { readCookie } from "../../helpers/helperMethods";
  import { ProductTypeId } from "../../helpers/constants";

  interface Props {
    avaliableProducts: AvaliableProducts;
    selectedProduct: Product | undefined;
    productOrder: string[];
    children?: import("svelte").Snippet;
  }

  let {
    avaliableProducts,
    selectedProduct = $bindable(),
    productOrder,
    children,
  }: Props = $props();

  const singleProduct =
    (avaliableProducts.fixedProducts && avaliableProducts.fixedProducts.length == 0) ||
    (avaliableProducts.variableProducts && avaliableProducts.variableProducts.length == 0);
  let showAnimationFixed = $state(false);
  let showAnimationVariable = $state(false);
  let showAnimationHourly = $state(false);
  let positionMouse = $state({ x: 0, y: 0 });

  // If there's only one product available and non selected already, we set that product
  if (singleProduct && !selectedProduct) {
    if (avaliableProducts.fixedProducts) {
      selectedProduct = avaliableProducts.fixedProducts[0];
    } else if (avaliableProducts.variableProducts) {
      selectedProduct = avaliableProducts.variableProducts[0];
    }
  }

  const handleMousemove = (event: MouseEvent) => {
    positionMouse.x = event.pageX;
    positionMouse.y = event.pageY - 50 - window.scrollY;
  };

  onMount(() => {
    document.addEventListener("mousemove", handleMousemove);
  });

  onDestroy(() => {
    document.removeEventListener("mousemove", handleMousemove);
  });

  const getText = () => (Math.random() < 0.5 ? "Hejja!" : "Kul!");

  const testDate = readCookie("test-skip-date-from");
  const isMoving = window.location.hash.includes("#flytt");
</script>

<Card class="mb-3 h-auto">
  {@render children?.()}
  {#if avaliableProducts && productOrder}
    {#each productOrder as orderItem}
      {#if orderItem === "variable"}
        {#if avaliableProducts.variableProducts}
          {#each avaliableProducts.variableProducts as variableProduct}
            <VariablePrice
              productId={variableProduct.id}
              onClick={() => (showAnimationVariable = true)}
              bind:selectedProduct
              product={variableProduct}
            />
          {/each}
        {/if}
      {/if}
      {#if orderItem === "hourly"}
        {#if avaliableProducts.hourlyProducts}
          {#each avaliableProducts.hourlyProducts as hourlyProduct}
            {@const skipDate = testDate || hourlyProduct.skipDateFrom}
            {@const alwaysShow = isMoving || hourlyProduct.typeId !== ProductTypeId.TIMPRIS}
            {#if alwaysShow || !skipDate || new Date() < new Date(skipDate)}
              <div class="h-auto">
                <VariablePrice
                  productId={hourlyProduct.id}
                  onClick={() => (showAnimationHourly = true)}
                  bind:selectedProduct
                  product={hourlyProduct}
                />
              </div>
            {/if}
          {/each}
        {/if}
      {/if}
      {#if orderItem === "fixed"}
        {#if avaliableProducts.fixedProducts}
          <FixedPrice
            onClick={() => (showAnimationFixed = true)}
            bind:selectedProduct
            products={avaliableProducts.fixedProducts}
          />
        {/if}
      {/if}
    {/each}
  {/if}
</Card>

{#if showAnimationVariable}
  <AnimatedText position={positionMouse}>{getText()}</AnimatedText>
{/if}
{#if showAnimationHourly}
  <AnimatedText position={positionMouse}>{getText()}</AnimatedText>
{/if}
{#if showAnimationFixed}
  <AnimatedText position={positionMouse}>{getText()}</AnimatedText>
{/if}
